import api, { apiEndpoints } from '../../../services/axios';

export async function getCidPhoneMapRest(cid: string): Promise<{ phoneNumber: string | null }> {
  const params = new URLSearchParams({ cid });

  const response = await api.get(`${apiEndpoints.getCidPhoneMap}?${params.toString()}`);
  return response.data;
}
